import React from "react";
import { CreateContainer } from "./ContainerCreate";
import { getMostCommentsSleeves } from "../../api/getSleeves";
import Skeleton from "react-loading-skeleton";

class MostCommentsSleevesContainer extends React.Component {
  componentDidMount() {
    this.props.request();
  }
  render = () => {
    const { data, loading, failure, render } = this.props;
    const results = (data && data.data) || [];
    const { sleeves } = results;
    if (loading) {
      return <Skeleton count={3} />;
    }
    if (!loading && sleeves.length === 0) {
      return null;
    }
    return render({ sleeves, loading, failure });
  };
}

export default CreateContainer(getMostCommentsSleeves, MostCommentsSleevesContainer);
